import { ILazyModules, ILazyProps } from '@websolutespa/bom-mixer-models';
import dynamic from 'next/dynamic';
import { NotFoundItem } from './not-found/not-found';
import { TextDescriptionItem } from './text-description/text-description';

export const LAZY_MODULES: ILazyModules = {
  'not-found': dynamic<ILazyProps<NotFoundItem>>(() => import('./not-found/not-found').then(
    module => module.NotFound
  )),
  'text-description': dynamic<ILazyProps<TextDescriptionItem>>(() => import('./text-description/text-description').then(
    module => module.TextDescription
  )),
};
